import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import TopicCard from "@/components/base/TopicCard";
import { getLatestTopics } from "@/lib/content";

const hotTags = ["综艺", "直播", "公关", "剪辑", "选秀", "票务", "粉丝社群", "宣发"];

export default function LatestArchive() {
  const latest = getLatestTopics(6);

  return (
    <section id="archive" className="bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-8xl">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="最新归档"
            title="刚刚整理完成的档案"
            description="按整理时间倒序排列，每份档案都附有时间线与对话实录，可逐条核对。"
          />
          <Link
            to="/topics"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            进入归档库
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="flex flex-col gap-4 lg:col-span-8">
            {latest.map((topic) => (
              <TopicCard key={topic.id} topic={topic} variant="list" />
            ))}
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 flex flex-col gap-6">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  常用标签
                </h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {hotTags.map((tag) => (
                    <Link
                      key={tag}
                      to={`/topics?q=${encodeURIComponent(tag)}`}
                      className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
                <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-quill-pen-line text-lg" />
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  有想让我们整理的线索？
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  把你认为信息混乱、说法不一的事件发给我们，编辑部会评估可整理度并排期。
                </p>
                <Link
                  to="/about#contact"
                  className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
                >
                  提交线索
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}